export const projectData = [
  {
    id: 0,
    title: "AIAPPAREL - AI Apparel Design",
    description:
      "Design And Order Custom Apparel Using AI\nDesign unique apparel effortlessly. Order full-color packages, or purchase high-quality DTF Transfers for your own printing needs.",
    imageSrc: "project0-img.png",
    link: "https://jeremy-ai-dev.vercel.app"
  },
  {
    id: 7,
    title: "Speedy - One-stop Payment Platform",
    description:
      "Welcome to Speedy, Simplifying Digital Transactions for You\nExperience seamless top-ups, bill payments, and rewards with our all-in-one app",
    imageSrc: "projecta-img.png",
    link: "https://speedy-opal.vercel.app/"
  },
  {
    id: 8,
    title: "Nesti - Find your Dream home",
    description:
      "Nesti - Find your Dream home\nWhether you’re buying, selling or renting, we can help you move forward.",
    imageSrc: "projectb-img.png",
    link: "https://ravinna-fe-dev.vercel.app"
  },
  {
    id: 1,
    title: "Hydreate - Hydrating Your Ideas",
    description:
      "Hydreate inspires you to dream higher, plan to reach beyond potential, bring team members together and achieve success. With this Software you can DREAM. PLAN. and ACHIEVE.",
    imageSrc: "project2-img.png",
    link: "https://web-hydreate.azurewebsites.net"
  },
  {
    id: 9,
    title: "ProcessRUS - Software Company",
    description:
      "ProcessRus is a dynamic and innovative software development company dedicated to transforming digital ideas into powerful, user-centric solutions.",
    imageSrc: "projectc-img.png",
    link: "https://dev-processrus.vercel.app"
  },
  {
    id: 10,
    title: "IMNGA Awards",
    description:
      "Celebrating International medical graduates, nursing graduates and Allied Healthcare Professionals",
    imageSrc: "projectd-img.png",
    link: "https://dev-ia.vercel.app"
  },
  {
    id: 11,
    title: "TwinklyTots - Highly-rated Nursery School",
    description:
      "A vibrant, highly-rated nursery school in Ikeja, Lagos fostering growth, filled with the best care, caring teachers, educational resources, playful spaces, and a nurturing environment that empowers children to thrive",
    imageSrc: "projecte-img.png",
    link: "https://dev-tt.vercel.app"
  },
  {
    id: 12,
    title: "SageByte - Software Company",
    description:
      "We A.I. Powered Web Solutions That Convert!\nElevate Your Online Presence with AI-Powered Web Solutions That Drive Conversions.",
    imageSrc: "projectg-img.png",
    link: "https://sagebyte-fe.vercel.app/"
  },
  {
    id: 2,
    title: "FRSC SM - Lagos",
    description:
      "This volunteer arm was created by the same FRSC statute Sec. 10 (1)… “the Corps” which shall consist of such number of uniform and non-uniform members as may be determined, from time to time, by the Commission. FRSC Establishment Act (2007).",
    imageSrc: "project3-img.png",
    link: "https://frscsm-lagos.org"
  },
  {
    id: 3,
    title: "STEP - FinTech",
    description:
      "The Social Payment App, For a Brave New World where you can, Connect, Interact & Transact with Friends, Creators & Businesses.",
    imageSrc: "project4-img.png",
    link: "https://web-staging.getstep.app"
  },
  {
    id: 4,
    title: "HovaTravels - Flight/Hotel Booking",
    description:
      "We are committed to giving the most wonderful travel experience through offering the most user friendly online booking solutions on the market. Mobile, tablet, laptop & desktop users enjoy a fully tailored experience while browsing our travel portal. We boast your travel experience with our technology.",
    imageSrc: "project5-img.png",
    link: "https://hovatravel.netlify.app"
  },
  {
    id: 5,
    title: "Real Estate - Find Homes Near You",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Eius molestias ratione assumenda reiciendis voluptatibus vel itaque. Quis quam, ratione nihil, pariatur atque nisi nostrum doloribus non quibusdam, saepe enim veniam.",
    imageSrc: "project7-img.png",
  },
  // {
  //   id: 0,
  //   title: "Pupilbase - School Wellbeing",
  //   description:
  //     "A very real and contemporary concern for schools is wellbeing. Not only are our students and families struggling in the wake of the epidemic and the current Cost of Living Crisis, but also our workers.\nThis Software is built to counter this issue.",
  //   imageSrc: "project1-img.png",
  //   link: "https://www.pupilbase.com"
  // },
];
